import React from 'react';
import styles from './Project.module.css';

const Project = ({ name, desc, visit, code, youTube, scanQr, role, tools, date }) => {
    return (
        <article className={styles.container}>
            <div className={styles.imgTitleContainer}>
                <h2 data-date={date} className={styles.nameBefore}>{name}</h2>
                <a 
                    href={visit || youTube}
                    target="_blank"
                    rel="noreferrer"
                    className={styles.imgContainer}
                >
                    <figure>
                        <img 
                            className={styles.img}
                            src={require(`../../common/assets/images/project_images/${name}_landscape2.png`)} 
                            alt="project_face" 
                        />
                    </figure>
                </a>
            </div>
            <div data-eventin={name === 'EventIn' ? true : null} className={styles.infoContainer}>
                <h2 data-date={date} className={styles.nameAfter}>{name}</h2>
                <h3 className={styles.desc}>{desc}</h3>
                <h3 className={styles.role}><strong className={styles.strong}>Role</strong>: {role}</h3>
                <div className={styles.toolsContainer}>
                    { 
                        tools.map(t => (
                            <span key={t} className={styles.tool}>{t}</span>

                        ))
                    }
                </div>
                <div className={styles.btnsContainer}>
                    { name === 'EventIn' ? 
                        <a
                            href={scanQr} 
                            target="_blank"
                            rel="noreferrer"
                            className={styles.btnCode}
                        >
                            SCAN QR
                        </a>
                    : null
                    }
                    <a 
                        className={styles.btnVisit}
                        href={visit ? visit : youTube} 
                        target="_blank"
                        rel="noreferrer"
                    >
                        {visit ? 'VISIT' : 'YOUTUBE'}
                    </a>
                    <a 
                        href={code} 
                        target="_blank"
                        rel="noreferrer"
                        className={styles.btnCode}
                    >
                        VIEW CODE
                    </a>
                </div>
            </div>
        </article>
    )
}

export default Project;